import { useMemo } from 'react'
import CloudTest from './CloudTest'
import { useI18n } from '../../../utils/i18n'
import { ThemeToggle } from '../../../components/ui/ThemeToggle'
import { LanguageToggle } from '../../../components/ui/LanguageToggle'
import { Button } from '../../../components/ui/Button'

function isDevTestHost(hostname) {
  const host = String(hostname || '').toLowerCase()
  if (!host) return false
  if (host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0') return true
  if (host === 'admin-dev.chamii.com') return true
  // Cloudflare Pages preview domains
  if (host.endsWith('.pages.dev')) return true
  return false
}

export default function PublicTest() {
  const { tx } = useI18n()
  const host = useMemo(() => {
    try {
      return window.location.hostname
    } catch {
      return ''
    }
  }, [])

  const allowed = isDevTestHost(host)

  return (
    <div className="chamii-viewport chamii-safe-top chamii-safe-bottom bg-brand-bg dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      <div className="max-w-6xl mx-auto px-6 py-10 space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="min-w-0">
            <div className="text-2xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">
              {tx({ zh: 'Chamii 云端测试台', en: 'Chamii Cloud Test Console' })}
            </div>
            <div className="mt-1 text-sm font-medium text-slate-600 dark:text-slate-300">
              {tx({
                zh: '免登录：快速验证 位置 / 天气 / 放歌 / 情绪 / 眼睛预览 / WS 链路。',
                en: 'No login required. Quick checks: location / weather / music / emotion / eyes preview / WS pipeline.',
              })}
            </div>
          </div>

          <div className="flex items-center gap-2">
            <ThemeToggle />
            <LanguageToggle />
            <Button
              variant="secondary"
              size="md"
              onClick={() => window.location.assign('/monitor')}
              title={tx({ zh: '需要登录；会跳转到 /login', en: 'Requires login; will redirect to /login' })}
            >
              {tx({ zh: '完整控制台（需登录）', en: 'Full console (login)' })}
            </Button>
          </div>
        </div>

        {!allowed ? (
          <div className="p-6 rounded-3xl bg-rose-50 dark:bg-rose-950/30 border-2 border-rose-200 dark:border-rose-900">
            <div className="text-lg font-black text-rose-700 dark:text-rose-200">
              {tx({ zh: '该测试入口仅允许在 dev 域名使用', en: 'This test entry is only enabled on dev hosts.' })}
            </div>
            <div className="mt-2 text-sm font-bold text-rose-600/80 dark:text-rose-200/80">
              {tx({ zh: '当前 host：{host}', en: 'Current host: {host}' }, { host: host || '-' })}
            </div>
          </div>
        ) : (
          <CloudTest />
        )}
      </div>
    </div>
  )
}
